import { allowViewScreenings } from '../../../../../backend/features/permissions';
import { AuthError, defineEntity } from '@juvare/platform-app/App';
import { columns, jasBoardVerificationHistorySchema, } from './types';
export const jasBoardVerificationHistoryEntityName = 'jasBoardVerificationHistory';
export function createJasBoardVerificationHistoryEntity() {
    return defineEntity({
        version: 2,
        columns,
        onTransformColumns: (_, params) => (Object.assign({ lastUpdatedAt: params.data.lastUpdatedAt, lastCheckedAt: params.data.lastCheckedAt, lastSuccessAt: params.data.lastSuccessAt, calculateAge: params.data.calculateAge }, params.data)),
        onMigrate: (params) => params.oldData,
        onAuthPost: () => {
            // no direct post is allowed, because entity is updated internally -
            // background task
            throw new AuthError('Unauthorized');
        },
        onAuthGet: () => {
            // no direct get is allowed nor used
            throw new AuthError('Unauthorized');
        },
        onAuthList: (_appState, userState, response) => {
            if (!allowViewScreenings(userState)) {
                throw new AuthError('Unauthorized');
            }
            return response;
        },
    }, jasBoardVerificationHistorySchema);
}
